export function ImageModalBackArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12H6"
        stroke="#555555"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18L6 12L12 6"
        stroke="#555555"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
